import React, { Component } from 'react';
import { connect } from 'react-redux';
import WeatherIcon from '../weatherIcon';
import './style.scss';

class CurrentWeather extends Component {
    getFormatDate = (date) => {
        return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    };

    render() {
        let { data } = this.props;
        if (!data) return <div>loading...</div>;
        let sunset = new Date(data.sys.sunset * 1000),
            sunrise = new Date(data.sys.sunrise * 1000);
        return (
            <div className="card-text current-weather d-flex flex-column flex-sm-row justify-content-around">
                <div className="d-flex justify-content-around">
                    <div className="temp d-flex align-self-center">
                        {Math.round(data.main.temp)}&deg;C
                    </div>
                    <div className="weather-icon d-flex align-self-center">
                        <WeatherIcon imgData={data.weather[0]}/>
                    </div>
                </div>
                <div className="align-self-center">
                    <div className="suntime">
                        <div className="sunrise">
                            Восход: {this.getFormatDate(sunrise)}
                        </div>
                        <div className="sunset">
                            Закат: {this.getFormatDate(sunset)}
                        </div>
                    </div>
                    <div className="humidity">
                        Влажность: {data.main.humidity}%
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        data: state.currentWeatherData
    }),
    dispatch => ({})
)(CurrentWeather);